import { render } from "./FirmaAccordion.vue?vue&type=template&id=bc293d4c&scoped=true"
import script from "./FirmaAccordion.vue?vue&type=script&lang=js"
export * from "./FirmaAccordion.vue?vue&type=script&lang=js"

import "./FirmaAccordion.vue?vue&type=style&index=0&id=bc293d4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc293d4c"]])

export default __exports__